<div class="p-grid">
	<div class="p-md-4 p-col-12">
		<div class="p-0 h-100">
			<div class="d-flex">
				<div class="display-10 mx-4 mt-2 mb-1">Online Store Messages</div>
			</div>
			<p-divider></p-divider>
			<div>Loading Message</div>
			<div class="mb-3">
				<textarea
					pInputTextarea
					(change)="changesToSaveChange.emit(true)"
					[(ngModel)]="venueSvc.ooVenue.loadingMessage"
					[maxlength]="500"
					style="height: 100px; width: 100%"
				></textarea>
			</div>
			<div>Outside of Order Time Range Message</div>
			<div class="mb-3">
				<textarea
					pInputTextarea
					(change)="changesToSaveChange.emit(true)"
					[(ngModel)]="venueSvc.ooVenue.outsideOfOrderTimeWindowMessage"
					[maxlength]="250"
					style="height: 100px; width: 100%"
				></textarea>
			</div>
			<div>Header Message</div>
			<div class="mb-3">
				<textarea
					pInputTextarea
					(change)="changesToSaveChange.emit(true)"
					[(ngModel)]="venueSvc.ooVenue.disclaimer"
					[maxlength]="500"
					style="height: 100px; width: 100%"
				></textarea>
			</div>
		</div>
	</div>
	<div class="p-md-4 p-col-12">
		<div class="p-0 h-100">
			<div class="d-flex">
				<div class="display-10 mx-4 mt-2 mb-1">Communication Messages</div>
			</div>
			<p-divider></p-divider>
			<div>SMS Message</div>
			<div class="mb-3">
				<textarea
					pInputTextarea
					(change)="changesToSaveChange.emit(true)"
					[(ngModel)]="venueSvc.ooVenue.smsMessage"
					[maxlength]="100"
					style="height: 100px; width: 100%"
				></textarea>
			</div>
			<div>Email Receipt Footer</div>
			<div class="mb-3">
				<textarea
					pInputTextarea
					(change)="changesToSaveChange.emit(true)"
					[(ngModel)]="venueSvc.ooVenue.receiptCustomText"
					[maxlength]="100"
					style="height: 100px; width: 100%"
				></textarea>
			</div>
		</div>
	</div>
	<div class="p-md-4 p-col-12">
		<div class="p-0 h-100">
			<div class="d-flex">
				<div class="display-10 mx-4 mt-2 mb-1">Venue Admin Order</div>
			</div>
			<p-divider></p-divider>
			<div>Email Message Threshold</div>
			<div class="mb-3 w-100">
				<p-inputNumber
					#orderEmailTotalThresholdInput
					(ngModelChange)="changesToSaveChange.emit(true)"
					[(ngModel)]="venueSvc.ooVenue.orderTotalEmailThreshold"
					prefix="$"
					inputStyleClass="text-right"
					styleClass="w-100"
					class="w-100"
				></p-inputNumber>
			</div>
			<div>SMS Message Threshold</div>
			<div class="mb-3 w-100">
				<p-inputNumber
					#orderSmsTotalThresholdInput
					(ngModelChange)="changesToSaveChange.emit(true)"
					[(ngModel)]="venueSvc.ooVenue.orderTotalSmsThreshold"
					prefix="$"
					inputStyleClass="text-right"
					styleClass="w-100"
					class="w-100"
				></p-inputNumber>
			</div>

			<div>SMS Number</div>
			<div class="small"><i>separate multiple destinations with a comma</i></div>
			<div class="mb-3">
				<input
					pInputText
					#orderSmsNumberInput
					name="orderSmsNumberInput"
					type="text"
					(ngModelChange)="changesToSaveChange.emit(true)"
					[(ngModel)]="venueSvc.ooVenue.orderSmsNotificationNumber"
					class="w-100"
				/>
			</div>
		</div>
	</div>
</div>
